<template>
  <router-link
    :to="{ name: 'orderDetail', params: { orderId: order.id } }"
    :aria-label="t('orders.orderNumParam', { param: order.id })"
    class="related-order"
  >
    <Card class="related-order-card elevated">
      <template #content>
        <div class="related-order-card-content w-full flex flex-column">
          <div class="flex justify-content-between">
            <div
              class="related-order-card-order-number font-medium text-gray-darkest"
            >
              {{ t('orders.orderNumParam', { param: order.id }) }}
            </div>
            <router-link
              :to="{ name: 'orderDetail', params: { orderId: order.id } }"
              class="related-order-card-link"
            >
              {{ t('common.viewDetails') }}
              <i class="pi pi-arrow-right"></i>
            </router-link>
          </div>
          <div class="flex flex-gap-1 align-items-center text-gray-darkest">
            <span>
              {{ order?.origin?.location?.cityState }}
            </span>
            <i class="pi pi-arrow-right text-gray-dark"></i>
            <span>
              {{ order?.destination?.location?.cityState }}
            </span>
          </div>
        </div>
      </template>
    </Card>
  </router-link>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { Order } from '@/model';

import Card from 'primevue/card';

const props = defineProps({
  order: {
    type: Order,
    default: () => new Order(),
  },
});
const { order } = toRefs(props);
const { t } = useI18n();
</script>

<style>
:root {
  --related-order-link-color: var(--p-primary-500);
  --related-order-link-text-decoration: none;
}

a.related-order {
  --p-card-body-padding: var(--sp-4);

  text-decoration: none;

  .related-order-card.p-card {
    &:hover {
      --p-card-background: var(--p-surface-100);
      --related-order-link-color: var(--p-primary-600);
      --related-order-link-text-decoration: underline;
    }

    .related-order-card-content {
      gap: var(--sp-2);

      .related-order-card-link {
        display: flex;
        align-items: center;
        gap: var(--sp-1);
        color: var(--related-order-link-color);
        text-decoration: var(--related-order-link-text-decoration);

        i.pi {
          font-size: 10px;
        }
      }
    }
  }
}
</style>
